import {
  Text,
  IconArrowCornerDownLeft,
  GreyGrey40,
  GreyGrey60,
  GreyGrey80,
  Primary13Regular,
  Primary12SemiBold,
  ShadowXs,
  Flex
} from '@sequencehq/core-components'
import { FC } from 'react'
import styled from 'styled-components'

interface ShortcutKeyProps {
  keys: string[]
  isSimultaneous?: boolean
}

export const ShortcutKey: FC<ShortcutKeyProps> = ({
  keys,
  isSimultaneous = false
}) => (
  <Flex gap="4px" flexShrink={0} alignItems="center">
    {keys.map((key, keyIndex) => (
      <>
        <KeyCap key={`key-${keyIndex}`}>
          {key === 'Enter' ? (
            <IconArrowCornerDownLeft size={12} color="currentColor" />
          ) : (
            key
          )}
        </KeyCap>
        {keyIndex < keys.length - 1 && (
          <Text
            key={`text-${keyIndex}`}
            {...Primary13Regular}
            color={GreyGrey60}
          >
            {isSimultaneous ? '+' : 'then'}
          </Text>
        )}
      </>
    ))}
  </Flex>
)

const KeyCap = styled.kbd`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  min-width: 20px;
  background: white;
  color: ${GreyGrey80};
  border: 1px solid ${GreyGrey40};
  border-radius: 4px;
  text-transform: uppercase;
  box-shadow: ${ShadowXs};
  font-family: ${Primary12SemiBold.fontFamily};
  font-weight: ${Primary12SemiBold.fontWeight};
  line-height: ${Primary12SemiBold.lineHeight};
  letter-spacing: ${Primary12SemiBold.letterSpacing};
  font-size: 11px;
`
